exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-button[data-v-1330eeba]{margin-top:.5rem;width:100%}@media (min-width:1000px){.filter-button[data-v-1330eeba]{width:auto;flex-grow:1;margin-top:0;margin-left:.25rem}}", ""]);

// exports
